import React, { useEffect, useRef, useState } from "react";
import { FiMoreHorizontal } from "react-icons/fi";

const AnnouncementActionsMenu = ({ items }) => {
  const [position, setPosition] = useState(null);
  const buttonRef = useRef(null);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!position) return undefined;
    const closeOnOutsideClick = (event) => {
      if (
        menuRef.current?.contains(event.target) ||
        buttonRef.current?.contains(event.target)
      ) {
        return;
      }
      setPosition(null);
    };
    const close = () => setPosition(null);
    document.addEventListener("mousedown", closeOnOutsideClick);
    window.addEventListener("scroll", close, true);
    window.addEventListener("resize", close);
    return () => {
      document.removeEventListener("mousedown", closeOnOutsideClick);
      window.removeEventListener("scroll", close, true);
      window.removeEventListener("resize", close);
    };
  }, [position]);

  const toggleMenu = (event) => {
    event.stopPropagation();
    if (position) {
      setPosition(null);
      return;
    }
    const bounds = buttonRef.current.getBoundingClientRect();
    setPosition({
      top: bounds.bottom + 4,
      right: window.innerWidth - bounds.right,
    });
  };

  return (
    <>
      <button
        ref={buttonRef}
        type="button"
        aria-label="More actions"
        aria-haspopup="menu"
        aria-expanded={Boolean(position)}
        onClick={toggleMenu}
        className="rounded-md border border-mediumgray px-2 py-1 text-darkergray hover:bg-lightgray"
      >
        <FiMoreHorizontal size={14} />
      </button>
      {position && (
        <div
          ref={menuRef}
          role="menu"
          style={{ top: position.top, right: position.right }}
          className="fixed z-50 min-w-36 rounded-md border border-mediumgray bg-white py-1 shadow-lg"
        >
          {items.map((item) => (
            <button
              key={item.label}
              type="button"
              role="menuitem"
              onClick={(event) => {
                event.stopPropagation();
                setPosition(null);
                item.onSelect();
              }}
              className={`block w-full px-3 py-2 text-left text-sm hover:bg-lightgray ${
                item.isDestructive ? "text-red-700" : "text-darkergray"
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </>
  );
};

export default AnnouncementActionsMenu;
